import { render } from "./Contact.vue?vue&type=template&id=9174f8e8"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render

export default script